module.exports = __webpack_public_path__ + "img/undraw_calculator_re_alsc.a63917db.svg";